module.exports = __webpack_public_path__ + "media/images/ground-0c6477d32bc4234c5f878de61984059a.png";